<template>
  <div class="podcast-list">
    <h2>Available Podcasts</h2>
    <ul>
      <li
        v-for="podcast in reversedPodcasts"
        :key="podcast.id"
        @click="selectPodcast(podcast)"
        :class="{ selected: selectedPodcastId === podcast.id }"
      >
        <div class="podcast-title">{{ formatTitle(podcast.title) }}</div>
        <div class="podcast-date">{{ formatDate(podcast.date) }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PodcastList",
  props: {
    selectedPodcastId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      podcasts: [],
    };
  },
  computed: {
    reversedPodcasts() {
      return [...this.podcasts].sort((a, b) => {
        // Extract year, month, day, hour, and minute from the date string
        const dateA = a.date.slice(0, 8); // YYYYMMDD
        const dateB = b.date.slice(0, 8); // YYYYMMDD
        
        // Compare the date strings directly
        return dateB.localeCompare(dateA);
      });
    }
  },
  created() {
    this.fetchPodcastList();
  },
  methods: {
    async fetchPodcastList() {
      try {
        const response = await fetch(
          `${process.env.BASE_URL}json/podcast-list.json`
        );
        this.podcasts = await response.json();
      } catch (error) {
        console.error("Error fetching podcast list:", error);
      }
    },
    selectPodcast(podcast) {
      this.$emit("select-podcast", {
        id: podcast.id,
        title: this.formatTitle(podcast.title),
        url: podcast.url,
        date: podcast.date,
      });
    },
    formatTitle(title) {
      return title.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    formatDate(dateString) {
      const year = dateString.slice(0, 4);
      const month = dateString.slice(4, 6);
      const day = dateString.slice(6, 8);
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.podcast-list h2 {
  color: var(--color-7);
  border-bottom: 2px solid var(--color-5);
  padding-bottom: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.podcast-list ul {
  list-style-type: none;
  padding: 0;
}

.podcast-list li {
  cursor: pointer;
  padding: 15px;
  border-bottom: 1px solid var(--color-4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  transition: background-color 0.3s ease;
}

.podcast-list li:last-child {
  border-bottom: none;
}

.podcast-list li:hover {
  background-color: var(--color-3);
}

.podcast-list li.selected {
  background-color: var(--color-4);
  border-left: 4px solid var(--color-7);
}

.podcast-list li.selected .podcast-title {
  color: var(--color-8);
}

.podcast-list li.selected .podcast-date {
  color: var(--color-7);
}

.podcast-title {
  font-weight: bold;
  margin-right: 10px;
  color: var(--color-8);
}

.podcast-date {
  color: var(--color-6);
  font-size: 0.9em;
}

@media (max-width: 768px) {
  .podcast-list li {
    flex-direction: column;
    align-items: flex-start;
  }

  .podcast-title {
    margin-bottom: 5px;
  }
}
</style>
